import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import {TopBarBlock} from '../common/MainBlocks';
import TabLinkGroup from '../common/TabLinkGroup';
import TabLink from '../common/TabLink';

const Topbar = ({history, location, role}) => {
  const {t} = useTranslation();
  const openProfile = () => {
    if ((role === 'administrator') && (location.pathname === '/settings/profile')) {
      history.push('/settings/administration');
      return;
    }

    history.push('/settings/profile');
  };

  return (
    <TopBarBlock fixed white>
      <LeftSide>
        <TabLinkGroup>
          <TabLink
            to="/settings/profile"
            onClick={openProfile}>
            {t('profile')}
          </TabLink>
        </TabLinkGroup>
      </LeftSide>
    </TopBarBlock>
  );
};

const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

Topbar.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  role: PropTypes.string,
};

Topbar.defaultProps = {
  role: '',
};

const mapStateToProps = ({manager}) => ({
  role: manager.data?.role,
});

export default connect(mapStateToProps)(withRouter(Topbar));
